import React from 'react';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
const months = [{
  value: '1',
  label: 'January'
}, {
  value: '2',
  label: 'February'
}, {
  value: '3',
  label: 'March'
}, {
  value: '4',
  label: 'April'
}, {
  value: '5',
  label: 'May'
}, {
  value: '6',
  label: 'June'
}, {
  value: '7',
  label: 'July'
}, {
  value: '8',
  label: 'August'
}, {
  value: '9',
  label: 'September'
}, {
  value: '10',
  label: 'October'
}, {
  value: '11',
  label: 'November'
}, {
  value: '12',
  label: 'December'
}];
const days = Array.from({
  length: 31
}, (_, i) => ({
  value: String(i + 1),
  label: String(i + 1)
}));
const years = Array.from({
  length: 10
}, (_, i) => {
  const y = 2026 - i;
  return {
    value: String(y),
    label: String(y)
  };
});
const dateSelect = 'h-10 rounded-md border border-slate-300 bg-white px-2 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400';
export function ExportUsers() {
  return <div className="space-y-6" data-id="element-1086" data-mp="25rgnbuxaqlkn">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-1087" data-mp="1r0zmacokpxoa">Export Users</h1>

      <Card data-id="element-1088" data-mp="1qymvrb4r2ezm">
        <CardContent className="pt-6 space-y-5 max-w-sm" data-id="element-1089" data-mp="1vzaw4nevc86i">
          <div data-id="element-1090" data-mp="1vzu2r7z2ja58">
            <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1091" data-mp="1vxg6ivsnjrw3">
              Start Date
            </label>
            <div className="flex items-center gap-1" data-id="element-1092" data-mp="2onyb6190y1bm">
              <select defaultValue="2" className={dateSelect} data-id="element-1093" data-mp="2onpzudsjv42j">
                {months.map(m => <option key={m.value} value={m.value} data-id="element-1094" data-mp="29qpgaxkiiff5">
                    {m.label}
                  </option>)}
              </select>
              <span className="text-slate-500" data-id="element-1095" data-mp="ybajbtsaznk1">/</span>
              <select defaultValue="11" className={`${dateSelect} w-16`} data-id="element-1096" data-mp="ydwq3r7ddz17">
                {days.map(d => <option key={d.value} value={d.value} data-id="element-1097" data-mp="138itp877mnaq">
                    {d.label}
                  </option>)}
              </select>
              <span className="text-slate-500" data-id="element-1098" data-mp="30zsaum189uzg">/</span>
              <select defaultValue="2026" className={`${dateSelect} w-20`} data-id="element-1099" data-mp="2w7r23a39qme6">
                {years.map(y => <option key={y.value} value={y.value} data-id="element-1100" data-mp="2r961h9k3u0p7">
                    {y.label}
                  </option>)}
              </select>
            </div>
          </div>

          <div data-id="element-1101" data-mp="2i87v4km71h3g">
            <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1102" data-mp="2i7g8hzakqtpb">
              End Date
            </label>
            <div className="flex items-center gap-1" data-id="element-1103" data-mp="2d9o8ehzs01a1">
              <select defaultValue="2" className={dateSelect} data-id="element-1104" data-mp="289s5yn6q8hwl">
                {months.map(m => <option key={m.value} value={m.value} data-id="element-1105" data-mp="bh9t7qom9axb">
                    {m.label}
                  </option>)}
              </select>
              <span className="text-slate-500" data-id="element-1106" data-mp="6iyi7cml4udi">/</span>
              <select defaultValue="11" className={`${dateSelect} w-16`} data-id="element-1107" data-mp="e2hjiyzp5aaw">
                {days.map(d => <option key={d.value} value={d.value} data-id="element-1108" data-mp="j099vokp0ocz">
                    {d.label}
                  </option>)}
              </select>
              <span className="text-slate-500" data-id="element-1109" data-mp="nu3rmmgqmt9f">/</span>
              <select defaultValue="2026" className={`${dateSelect} w-20`} data-id="element-1110" data-mp="spsvh1zsiwbj">
                {years.map(y => <option key={y.value} value={y.value} data-id="element-1111" data-mp="3ra12yyqmy79c">
                    {y.label}
                  </option>)}
              </select>
            </div>
          </div>

          <div className="pt-2" data-id="element-1112" data-mp="50go87o0wybv">
            <Button data-id="element-1113" data-mp="53coi2ncfz3h">Export</Button>
          </div>
        </CardContent>
      </Card>
    </div>;
}